
import React from 'react';

interface PriorityDisplayProps {
  quadrant: string;
}

const quadrantConfig = {
  'do-first': {
    label: 'Important & Urgent – Do Now',
    emoji: '🚨'
  },
  'schedule': {
    label: 'Important & Not Urgent – Schedule',
    emoji: '🗓️'
  },
  'delegate': {
    label: 'Not Important & Urgent – Delegate',
    emoji: '🤝'
  },
  'eliminate': {
    label: 'Not Important & Not Urgent – Eliminate',
    emoji: '🗑️'
  }
};

export const PriorityDisplay: React.FC<PriorityDisplayProps> = ({ quadrant }) => {
  const config = quadrantConfig[quadrant as keyof typeof quadrantConfig];
  
  if (!config) return null;

  return (
    <div className="text-xs text-gray-600 dark:text-gray-400 mt-2 pt-2 border-t border-gray-100 dark:border-gray-700 pl-2">
      <div className="flex items-center gap-2">
        <span className="text-base">{config.emoji}</span>
        <span>{config.label}</span>
      </div>
    </div>
  );
};

